import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { INPUTS_PROPS, LOCAL_STORAGE_ITEMS_KEYS } from "../../../../../enums/Enums";
import Strings from "../../../../../resources/Strings";
import {
  getErrorMessage,
  isEmail,
  isRequired,
} from "../../../../../utils/FormUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import PasswordInput from "../../../Inputs/CustomInputs/PasswordInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "./LoginForm.module.css";
import * as actionsService from "../../../../../services/ActionsService/ActionsService";
import * as encryptedLocalStorageActions from "../../../../../managers/Storage/EncryptedLocalStorageActions";
import store from "../../../../../redux/Store";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import { useSelector } from "react-redux";
import { showErrorMessage, showLoginErrorMessage } from "../../../../../utils/MessagesUtils";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";

const LoginForm = (props) => {
  const isShowLoadingSpinner = useSelector((state) => state.common.isShowLoadingSpinner);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    isCurrentStepValid: false,
    isStepSubmitted: false,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const hasError = Object.values(errors).some((hasError) => hasError);
    handleCurrentStepValidity(hasError);
  }, [errors]);

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setFormData({ ...formData, isCurrentStepValid: !hasError });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    if (formData.isCurrentStepValid) {
      actionsService
        .login(formData.email, formData.password, true, false)
        .then((response) => {
          if (response.data.isSuccess) {
            // handle cached image - get the most updated image instead of using the cached one
            if (response.data.entity?.utronUser?.image !== null) {
              response.data.entity.utronUser.image += `?=${new Date().getTime()}`;
            }

            encryptedLocalStorageActions.setStorageItem(
              LOCAL_STORAGE_ITEMS_KEYS.AUTHENTICATION,
              response.data.entity
            );
            store.dispatch(userActions.login(response.data));
          }
          else {
            store.dispatch(commonActions.setIsShowLoadingSpinner(false));
            showLoginErrorMessage();
          }
        })
        .catch((error) => {
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
          //showErrorMessage(error);
        });
    }
  };

  const handleForgetPassword = () => {
    props.handleForgetPassword();
  };

  return (
    <div className={classes.loginForm}>
      <div className={classes.title}>{Strings.TITLES.GMT_LOGIN}</div>
      <div className={classes.subTitle}>
        {Strings.LOGIN_INSTRUCION}
      </div>
      <form name="Login" onSubmit={handleSubmit}>
        <div className={classes.fileds}>
          <TextInput
            label={Strings.INPUT_LABELS.EMAIL}
            id={INPUTS_PROPS.EMAIL}
            value={formData.email}
            isStepSubmitted={formData.isStepSubmitted}
            handleError={handleError}
            onChange={handleChange}
            hasError={!isEmail(formData.email).isValid}
            errorMessage={getErrorMessage(isEmail(formData.email))}
          />
          <PasswordInput
            label={Strings.INPUT_LABELS.PASSWORD}
            id={INPUTS_PROPS.PASSWORD}
            value={formData.password}
            onChange={handleChange}
            isStepSubmitted={formData.isStepSubmitted}
            handleError={handleError}
            hasError={!isRequired(formData.password).isValid}
            errorMessage={getErrorMessage(isRequired(formData.password))}
            
          />
        </div>

        <div className={classes.loginButton}>
          <EllipseButton type="submit">{Strings.LOGIN}</EllipseButton>
        </div>

        <Button
          disabled={isShowLoadingSpinner}
          className={classes.forgetPasswordButton}
          onClick={handleForgetPassword}
        >
          {Strings.FORGET_PASSWORD}
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;
